import { ContactForm } from '@akyga/shared-ui/ContactForm';

export default ContactForm;
